import React from 'react'

function LabBilling() {
  return (
    <div>Lab Billing</div>
  )
}

export default LabBilling